module.exports = __webpack_public_path__ + "static/media/email_circle_icon.47ae9421.svg";